import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical, X } from 'lucide-react';
import { ProductImage } from '../../types';

interface SortableItemProps {
  id: string;
  image: ProductImage;
  onRemove: (id: string) => void;
}

export function SortableItem({ id, image, onRemove }: SortableItemProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 1 : 0,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex items-center bg-white p-2 rounded-lg border border-gray-200"
      {...attributes}
    >
      <div className="w-16 h-16 flex-shrink-0 relative rounded-md overflow-hidden">
        <img
          src={image.url}
          alt="Product"
          className="w-full h-full object-cover"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.src = 'https://placehold.co/64x64/e2e8f0/64748b?text=Error';
          }}
        />
      </div>
      <div className="flex-1 px-4">
        <p className="text-sm text-gray-600">
          Image {image.order + 1}
        </p>
      </div>
      <button
        type="button"
        onClick={() => onRemove(image.id)}
        className="p-1 text-gray-400 hover:text-red-500"
      >
        <X className="w-5 h-5" />
      </button>
      <div className="cursor-move" {...listeners}>
        <GripVertical className="w-5 h-5 text-gray-400" />
      </div>
    </div>
  );
}